import { getCertificateCreateFieldSelector } from "raft/CertificateForm";
import { getUnitCreateFieldSelector } from "raft/UnitForm";
import * as React from "react";
import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import Props from "./index.d";

interface GFCFieldSet_FieldSetDiv extends Props {
  children: React.ReactNode;
}

const NormChecker: React.FC<GFCFieldSet_FieldSetDiv> = ({ children, norm, entity }) => {
  const __normListAtomActive = useMemo(
    () => getCertificateCreateFieldSelector({ formVersion: "active" })("__normList"),
    []
  );
  const __normListAtomMatrix = useMemo(
    () => getCertificateCreateFieldSelector({ formVersion: "matrixCertificateCreate" })("__normList"),
    []
  );
  const __normListAtomUnitsActive = useMemo(
    () => getUnitCreateFieldSelector({ formVersion: "active" })("__normList"),
    []
  );
  const __normListAtomUnitsMatrix = useMemo(
    () => getUnitCreateFieldSelector({ formVersion: "matrixUnitCreate" })("__normList"),
    []
  );

  const __normListActive = useRecoilValue(__normListAtomActive);
  const __normListMatrix = useRecoilValue(__normListAtomMatrix);
  const __normListUnitsActive = useRecoilValue(__normListAtomUnitsActive);
  const __normListUnitsMatrix = useRecoilValue(__normListAtomUnitsMatrix);

  const CheckedChildren = useMemo(() => {
    // Use the norm list from whichever form has data
    const certificateNormList = __normListMatrix || __normListActive || "";
    const unitNormList = __normListUnitsMatrix || __normListUnitsActive || "";
    const norms = (entity === "Certificate" ? certificateNormList : unitNormList) ?? "";

    const includesGreater10 = norms.includes("10") || norms.includes("20") || norms.includes("30");
    const selectedNormGreater10 = norm === "10" || norm === "20" || norm === "30";
    const includesIs5 = norms.includes("05");

    if (includesGreater10 && selectedNormGreater10) return <>{children}</>;
    if (norm === "05" && includesIs5) return <>{children}</>;
    return null;
  }, [__normListActive, __normListMatrix, __normListUnitsActive, __normListUnitsMatrix, entity, norm, children]);

  return CheckedChildren;
};

export default NormChecker;
